import React from "react";

const PricingTableHead = ({key}) => {
    return (
        <thead className="smartTable-thead" style={{zIndex:1}} key={key}>
            <tr className="pricingTable">
                <th colSpan={7}></th>
                <th colSpan={3} className="lhs_thead text-center">LHS</th>
                <th colSpan={3} className="rhs_thead text-center">RHS</th>
                <th colSpan={2}></th>
            </tr>
            <tr className="pricingTable">
                <th
                    scope="col"
                    style={{
                        width: "180px",
                    }}
                >
                    Commodity
                </th>
                <th className="w_100" scope="col">Sieve Size</th>
                <th className="w_100" scope="col">MM Size</th>
                <th className="w_100" scope="col">PP Wt.</th>
                <th scope="col">PCS</th>
                <th className="w_100" scope="col">Setting</th>
                <th className="" style={{width:"160px"}} scope="col">Lot Code</th>
                <th className="w_100 lhs_thead " scope="col">Cts/Wt</th>
                <th className="w_100 lhs_thead text-right" scope="col">Rate</th>
                <th className="w_100 lhs_thead text-right" scope="col">Amount</th>
                <th className="w_100 rhs_thead text-left" scope="col">Cts/Wt</th>
                <th className="w_100 rhs_thead text-right" scope="col">Rate</th>
                <th className="w_100 rhs_thead text-right" scope="col">Amount</th>
                <th scope="col" style={{width:"150px"}}>Customer Master </th>
                <th scope="col" style={{
                    whiteSpace: "nowrap"
                }}>Client Stone</th>
            </tr>
            
        </thead>
    );
};
export default PricingTableHead;
